import * as yup from 'yup';

const phoneNumberPattern = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s/0-9]*$/g;
const websiteRegex = /^(https?:\/\/)?([a-z0-9]+(\.[a-z]{2,}){1,3}|www\.[a-z0-9]+(\.[a-z]{2,}){1,3})(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?(\.(com|org|gov|gob|edu|net|io|ar|otro))$/

export const REQUIRED_FIELD_MESSAGE = 'Campo obligatorio';

export const RequiredStringSchema = yup.string().typeError(REQUIRED_FIELD_MESSAGE).required(REQUIRED_FIELD_MESSAGE).min(1, REQUIRED_FIELD_MESSAGE)
export const RequiredSchema = yup.mixed().required(REQUIRED_FIELD_MESSAGE);

export const RequiredNumberSchema = yup.number().required(REQUIRED_FIELD_MESSAGE).typeError("El campo debe ser numérico")

export const RequiredPositiveNumberSchema = yup.number().required(REQUIRED_FIELD_MESSAGE).typeError('Ingrese un número válido').min(0,'Ingrese un número válido');

export const RequiredBooleanTrueSchema = yup.boolean().test('testBooleanTrue', REQUIRED_FIELD_MESSAGE, (value) => !!value);

export const WebsiteSchema = yup.string().matches(websiteRegex, 'Web inválida').notRequired()

export const MailRequiredSchema = yup.string().email('Mail inválido').required('Debe completar el mail')
export const MailSchema = yup.string().email('Mail inválido').notRequired()
export const PhoneNumberSchema = yup.string().matches(phoneNumberPattern, 'Teléfono Inválido')
export const NotRequiredSchema = yup.mixed().notRequired()
export const CuitCuilSchema = yup.number().typeError('CUIT / CUIL debe ser un número').integer('CUIL / CUIT inválido').positive('CUIL / CUIT inválido');
export const DNISchema = yup.number().typeError('DNI debe ser un número').integer('DNI inválido').positive('DNI inválido');

export const MultipleFileSchema = yup.mixed()
    .test("required", REQUIRED_FIELD_MESSAGE, (file) => {
        return !!file;

    })
    .test("fileSize", "El archivo es demasiado grande", (file: any) => {
        const size = file?.reduce?.((accumulator: number, currFile: File) => accumulator + currFile.size, 0) || 0

        return file && size <= 20000000;
    })

